var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickUnfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002793"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 30",
    x: 0.27972,
    y: 0.27972,
    width: 19.4406,
    height: 19.4406,
    rx: 9.72028,
    fill: "white",
    stroke: "#808191",
    strokeWidth: 0.559441
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickUnfilled);
export default __webpack_public_path__ + "static/media/tick_unfilled.8090debc527c761050cad2f075d72f62.svg";
export { ForwardRef as ReactComponent };